export interface IVisitConsentClientRequest {
  reasonForVisit: string;
  treatmentStarted: boolean;
  previousTreatment: string;
  isCurrentlyOnMedications: boolean;
  medicationList: string;
  optInToAudioRecording: boolean | undefined;
}

export class VisitConsentClientRequest implements IVisitConsentClientRequest {
  reasonForVisit: string;
  treatmentStarted: boolean;
  previousTreatment: string;
  isCurrentlyOnMedications: boolean;
  medicationList: string;
  optInToAudioRecording: boolean | undefined;

  constructor(params: IVisitConsentClientRequest) {
    this.reasonForVisit = _.defaultTo(params.reasonForVisit, '');
    this.treatmentStarted = _.defaultTo(params.treatmentStarted, false);
    this.previousTreatment = _.defaultTo(params.previousTreatment, '');
    this.isCurrentlyOnMedications = _.defaultTo(
      params.isCurrentlyOnMedications,
      false,
    );
    this.medicationList = _.defaultTo(params.medicationList, '');
    this.optInToAudioRecording = params.optInToAudioRecording;
  }
}
